import React from "react";
import {useHistory} from 'react-router-dom'
import {setPathForRouter} from "@common-helpers/set-rout-path"
import {SendUserData} from "@common-helpers/userData"


export const NextBtn = ({nextOnClick,  nextCallback, nextRout, nextPageId, isDisabled = false, children, componentName, answersOnQuestions}) => {

    const history = useHistory(),
          clickHandler = () => {
            localStorage.setItem('duration', 'forward')

            if(componentName === 'Sex'){

                let sex

                if(answersOnQuestions.Sex === 'woman'){
                    sex = 'f'
                } else if(answersOnQuestions.Sex === 'man'){
                    sex = 'm'
                }

                SendUserData({
                    click_id: localStorage.getItem('click_id'),
                    sex: sex
                });
            }

            if (typeof nextOnClick === 'function') {
                nextOnClick()
            } else {
                setPathForRouter(nextRout, nextPageId, false, history)
                typeof nextCallback === 'function' ? nextCallback() : null
            }


        },
    language = localStorage.getItem('lang')

    let text = 'Далее'

    if (language === 'eng'){
        text = 'Next'
    } else if (language === 'ger'){
        text = 'Nächste'
    } else if (language === 'fr'){
        text = 'Davantage'
    } else if (language === 'it'){
        text = 'Ulteriore'
    }

    return (<button className="next-btn"  disabled={isDisabled} onClick={clickHandler}>
        {children ? children : text}
    </button>)
}
